import React from 'react';
import PropTypes from 'prop-types';

export const Sorting = ({ width, height, ...props }) => (
  <svg
    data-icon='sorting'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M3 18v-2h6v2H3Zm0-5v-2h12v2H3Zm0-5V6h18v2H3Z'
    />
  </svg>
);

Sorting.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Sorting.defaultProps = {
  width: 24,
  height: 24,
};
